import styled from 'styled-components';

import { rgba, darken } from 'polished';

export const Container = styled.div`
  font-family: 'Sora', sans-serif;
  padding: 50px;
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.white};

  * {
    letter-spacing: 0px;
    line-height: initial;
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.xxl}px) {
    padding: 30px;
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.xl}px) {
    padding: 20px;
  }
`;

export const Wrapper = styled.div`
  max-width: 1500px;
  width: 100%;
  position: relative;

  > header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;

    @media only screen and (max-width: ${({ theme }) => theme.breakpoints.lg}px) {
      flex-direction: column;
      justify-content: center;
      text-align: center;

      > span {
        padding-top: 20px;
      }

      > button {
        margin-top: 15px;
      }
    }

    h1 {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.black};
      font-size: 28px;
      letter-spacing: 0px;
    }

    h3 {
      color: ${({ theme }) => theme.colors.grey};
      font-weight: 400;
      padding-top: 10px;
      padding-right: 20px;
    }

    span {
      color: ${({ theme }) => theme.colors.softBlack};

      strong {
        font-weight: 700;
      }
    }

    button {
      display: flex;
      align-items: center;
      padding: 13px 18px;
      border-radius: 5px;
      background-color: ${({ theme }) => theme.colors.main};
      border: none;
      transition: background-color 0.2s ease;
      white-space: nowrap;

      span {
        font-family: 'Sora', sans-serif;
        font-size: 15px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.white};
      }

      &:hover {
        background-color: ${({ theme }) => darken(0.03, theme.colors.main)};
      }

      &:hover {
        background-color: ${({ theme }) => darken(0.03, theme.colors.main)};
      }

      &.outline {
        background-color: ${({ theme }) => theme.colors.white};
        border: 1px solid ${({ theme }) => theme.colors.main};

        span {
          color: ${({ theme }) => theme.colors.main};
        }

        &:hover {
          background-color: ${({ theme }) => rgba(theme.colors.main, 0.1)};
        }
      }

      & + button {
        margin-left: 10px;
      }
    }

    button.outline {
      display: flex;
      align-items: center;
      border: 3px solid ${({ theme }) => theme.colors.lightGrey};
      padding: 13px 15px;
      border-radius: 5px;
      background-color: ${({ theme }) => theme.colors.white};
      transition: background-color 0.2s ease;

      span {
        font-family: 'Sora', sans-serif;
        font-size: 15px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.softBlack};
      }

      &:hover {
        background-color: ${({ theme }) => darken(0.03, theme.colors.white)};
      }
    }
  }

  > main {
    display: flex;
    padding-top: 60px;
    gap: 20px;
    flex-direction: column;

    @media (min-width: 768px) {
      flex-direction: row;
    }

    div.inputs-container {
      border: 2px solid ${({ theme }) => theme.colors.lightGrey};
      border-radius: 5px;
      padding: 20px;

      h3 {
        font-family: 'Sora', sans-serif;
        font-size: 16px;
        font-weight: 700;
        color: ${({ theme }) => theme.colors.black};
        padding-bottom: 30px;
      }

      div.days {
        display: flex;
        gap: 10px;
        justify-content: center;
        width: 100%;
        padding-bottom: 30px;

        button {
          width: 50px;
          height: 40px;
          border-radius: 5px;
          border: 2px solid ${({ theme }) => theme.colors.lightGrey};
          background-color: ${({ theme }) => theme.colors.white};
          font-family: 'Sora', sans-serif;
          font-size: 13px;
          font-weight: 500;
          color: #aeaeae;
          transition: all 0.2s ease;

          &:hover,
          &.active {
            border-color: ${({ theme }) => theme.colors.main};
            color: ${({ theme }) => theme.colors.black};
          }
        }
      }

      button.open-selection {
        font-family: 'Sora', sans-serif;
        font-size: 15px;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.white};
        background-color: ${({ theme }) => theme.colors.main};

        border-radius: 5px;
        border: none;
        transition: background-color 0.2s ease;

        padding: 13px 18px;

        &:hover {
          background-color: ${({ theme }) => darken(0.03, theme.colors.main)};
        }
      }
    }

    div.first-column,
    div.second-column {
      display: flex;
      flex-direction: column;
      gap: 20px;

      div.filled-container {
        padding: 20px;
        background-color: #f6f9fb;
        border-radius: 5px;
        border: none;

        label {
          font-family: 'Sora', sans-serif;
          font-size: 14px;
          font-weight: 700;
          color: ${({ theme }) => theme.colors.black};
          padding-left: 10px;
        }

        &.active {
          display: flex;
          align-items: center;
        }

        ul {
          padding-left: 16px;
          margin-top: -10px;

          li {
            list-style: disc;
            color: ${({ theme }) => theme.colors.grey};

            & + li {
              margin-top: 8px;
            }
          }
        }
      }

      div.inputs {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;

        div.input-content.half {
          width: calc(50% - 10px);
        }
      }

      div.input-content {
        display: flex;
        flex-direction: column;
        gap: 5px;
        width: 100%;

        label {
          font-family: 'Sora', sans-serif;
          font-size: 13px;
          font-weight: 500;
          color: ${({ theme }) => theme.colors.black};
        }
      }

      input:not([type='radio']),
      select {
        background-color: ${({ theme }) => theme.colors.white};
        border: 2px solid ${({ theme }) => theme.colors.lightGrey};
        border-radius: 5px;
        padding: 13px 15px;
        font-family: 'Sora', sans-serif;
        font-size: 13px;
        color: ${({ theme }) => theme.colors.black};
        width: 100%;
        transition: all 0.2s ease;

        &:focus {
          border-color: ${({ theme }) => theme.colors.main};
        }

        &.right {
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
        }

        &.left {
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
        }
      }

      div.option {
        input[type='radio'] {
          margin-right: 10px;
        }
      }

      div.input-wrapper {
        display: flex;

        span {
          background-color: ${({ theme }) => theme.colors.white};
          border: 2px solid ${({ theme }) => theme.colors.lightGrey};
          border-radius: 5px;
          padding: 13px 15px;
          font-family: 'Sora', sans-serif;
          font-size: 13px;
          font-weight: 700;
          color: ${({ theme }) => theme.colors.black};

          &.left {
            border-right: none;
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
          }

          &.right {
            border-left: none;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
          }
        }
      }
    }

    div.first-column {
      flex: 0.65;
    }

    div.second-column {
      flex: 0.35;
    }
  }
`;
